import * as React from 'react';
import { PageProps } from "src/models/common/ComponentProps";
import bindAllOfThis from "src/utils/BindThisHelper";
import { message } from 'antd';
import PhaserTicketTakerGame from 'src/games/TicketTakerGame/Main';

interface TicketTakerGameProps extends PageProps<{}> {
    onComplete?: () => void;
}

class TicketTakerGame extends React.Component<TicketTakerGameProps> {
    constructor(props: TicketTakerGameProps) {
        super(props);
        bindAllOfThis(this, TicketTakerGame.prototype);
    }

    completeGame() {
        return message.success("You finished the game!");
    }

    render() {
        return <div>
            <PhaserTicketTakerGame onComplete={this.completeGame}/>
        </div>;
    }
}

export default TicketTakerGame;



// WEBPACK FOOTER //
// ./src/pages/game/TicketTakerGame.tsx